(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
			name: 'DestinationContentAction',
		};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var $form           = $('form[name="'+form.name+'"]'),
			$destination_id = $('#destinationcontentaction-destination_id').val(),
			title_message   = 'The form could not be submitted for the following reason(s):<br><br><ul><li>Title must be provided</li></ul>';

		Adzuki.Editor('#destinationcontentaction-description', {
			height                : 100,
			init_instance_callback: function callback(editor) {
				editor.on('blur', function clicked(e) {
					disableButtons();
				});
			}
		});

		$('.btn.btn-primary[data-action="save-guide"]', $form).on('click', function saveGuide(e) {
			e.preventDefault();
			$('#destinationcontentaction-action').val('save');
			$('#destination-content-action').attr('action', Adzuki.base_uri + '/DestinationContents/save/');
			$('#destination-content-action').submit();
		});

		$('.btn.btn-primary[data-action="generate-preview"]', $form).on('click', function generatePreview(e) {
			var $title    = $.trim($('#destinationcontentaction-title').val());
			var $iFrame   = $('#guide-preview');
			var $spinner  = $('#destination-spinner');
			var has_error = false;

			e.preventDefault();

			if ($title.length === 0) {
				has_error = true;
				$('#destinationcontentaction-title').parent().addClass('has-error');

				Adzuki.StatusMessage('Error', title_message);
			}

			if (has_error === false) {
				$('#destinationcontentaction-title').parent().removeClass('has-error');

				$spinner.css('visibility', 'visible');
				$('#preview-text').removeClass('destination-info-fadein');
				$('#preview-text').addClass('destination-info-fadeout');
				$iFrame.attr('src', Adzuki.base_uri + '/DestinationContents/DestinationGuide/' + $destination_id + '/0/1');

				$('.action-button').each(function enableButtons() {
					$(this).removeClass('disabled');
				});
			}
		});

		$('.btn.btn-success[data-action="email"]', $form).on('click', function email(e) {
			// var guide_options = guideOptions();

			e.preventDefault();

			// document.location = Adzuki.base_uri + '/DestinationContents/email/' + $destination_id + '/' + guide_options;
			$('#destinationcontentaction-action').val('email');
			$('#destination-content-action').attr('action', Adzuki.base_uri + '/DestinationContents/email/' + $destination_id);
			$('#destination-content-action').submit();
		});

		$('.guide-options').change(function changedCheckboxes() {
			disableButtons();
		});

		$('#destinationcontentaction-title').blur(function changedCheckboxes() {
			disableButtons();
		});
	};

	form.success = function success(response)
	{
		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		$('.form-loader').css('visibility', 'hidden');

		if (typeof response.data === 'object') {
			$('#destinationcontentaction-id').val(response.data.id);
			$('#destination-guide-link').attr('href', response.data.link);
			$('#destination_guide_url').removeClass('hidden');
			$('#destination-guide-link').html(response.data.link);
			Adzuki.StatusMessage('success', 'Destination Guide Saved!');
		} else {
			location.href = response.data;
		}
	};

	// function guideOptions() {
	// 	var guide_options = '',
	// 		options       = [];

	// 	$('.guide-options').each(function getGuideOptions() {
	// 		if ($(this).attr('id') !== "map-change") {
	// 			if ($(this).prop('checked') === true) {
	// 				if (options.includes($(this).val()) === false) {
	// 					options.push($(this).val());
	// 				}
	// 			}
	// 		}
	// 	});

	// 	guide_options = options.join(',');

	// 	return guide_options;
	// }

	function disableButtons()
	{
		$('.action-button').each(function disableButtons() {
			$(this).addClass('disabled');
		});

		$('#preview-text').removeClass('destination-info-fadeout');
		$('#preview-text').html('<i class="'+Adzuki.FaIcon.getIconStyle('info_circle')+'"></i> Click "Generate Preview" to see your options');
		$('#preview-text').addClass('destination-info-fadein');
	}
}(jQuery, window.Adzuki || {}));